// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getPerformance } from "firebase/performance";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBxFDbXgLFs4j4GMCsgyOc2T8EbwxqJ_Mc",
  authDomain: "nlfgym.firebaseapp.com",
  projectId: "nlfgym",
  storageBucket: "nlfgym.appspot.com",
  messagingSenderId: "745173358598",
  appId: "1:745173358598:web:2445eec9bd2974dc62cb87",
  measurementId: "G-7H0NWW4X9L"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
//const db = getFirestore(app);
export const database  = getFirestore(app)
export const auth = getAuth(app);
export const db = getFirestore(app);
const perf = getPerformance(app);
export default app
// Useful helpers